import React, {useContext} from "react";
import {Fade} from "react-reveal";
import "./Resume.scss";
import Button from "../../components/button/Button";
import {resumeSection} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

export default function Resume() {
  const {isDark} = useContext(StyleContext);
  
  if (!resumeSection.display) {
    return null;
  }

  return (
    <Fade bottom duration={1000} distance="40px">
      <div className="resume-main" id="resume">
        <div className="resume-main-div">
          <div className="resume-text-div">
            <h1
              className={
                isDark ? "dark-mode resume-heading" : "resume-heading"
              }
            >
              {resumeSection.title}
            </h1>
            <p
              className={
                isDark
                  ? "dark-mode resume-text-subtitle"
                  : "resume-text-subtitle"
              }
            >
              {resumeSection.subtitle}
            </p>
            <div className="resume-button-div">
              <a
                href={require("../greeting/resume.pdf")}
                download="David_Yesung_Lee_Resume.pdf"
                className="download-link-button"
              >
                <Button text="Download Resume" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
} 